import { render, staticRenderFns } from "./PaypalCheckout.vue?vue&type=template&id=6b948d74&scoped=true"
import script from "./PaypalCheckout.vue?vue&type=script&lang=js"
export * from "./PaypalCheckout.vue?vue&type=script&lang=js"
import style0 from "./PaypalCheckout.vue?vue&type=style&index=0&id=6b948d74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b948d74",
  null
  
)

export default component.exports